import React, { Component } from 'react'
import { ThemeContext } from "../../../layouts/ThemeProvider"

import IntroSection from './IntroSection'
import LandingSection from './components/LandingSection'
import TestimonialsSection from './TestimonialsSection'

import '../../../../assets/sass/pages/landing/home/landing.scss'

import VIDEO from '../../../../assets/img/landing/video.png'
import FILTERS from '../../../../assets/img/landing/filters.png'
import WATCHLIST from '../../../../assets/img/landing/watchlist.png'
import MESSAGE from '../../../../assets/img/landing/message.png'
import METRICS from '../../../../assets/img/landing/metrics.png'
import EVALUATION from '../../../../assets/img/landing/evaluation.png'

import VIDEO_DARK from '../../../../assets/img/landing/video--dark.png'
import FILTERS_DARK from '../../../../assets/img/landing/filters--dark.png'
import WATCHLIST_DARK from '../../../../assets/img/landing/watchlist--dark.png'
import MESSAGE_DARK from '../../../../assets/img/landing/message--dark.png'
import METRICS_DARK from '../../../../assets/img/landing/metrics--dark.png'
import EVALUATION_DARK from '../../../../assets/img/landing/evaluation--dark.png'

class Landing extends Component {
    constructor(props) {
        super(props)
    }

    render() {
        return (
            <div className="landing-page">
                {this.renderIntroSection()}
                {this.renderFeaturesSections()}
                {this.renderTestimonialsSection()}
            </div>
        )
    }

    renderIntroSection = () => {
        return (
            <IntroSection />
        )
    }

    renderFeaturesSections = () => {
        const { sections } = this.props;

        return sections.map(({ title, texts, image, align = 'left' }) => (
            <LandingSection
                key={title}
                title={title}
                texts={texts}
                image={image[this.context]}
                align={align}
            />
        ))
    }

    renderTestimonialsSection = () => {
        const { testimonials } = this.props;

        return (
            <TestimonialsSection testimonials={testimonials} />
        )
    }

    static contextType = ThemeContext
    static defaultProps = {
        sections: [
            {
                title: "Video library and Detailed Analytics reports",
                image: {dark: VIDEO_DARK, default: VIDEO},
                texts: [
                    "Qui qui ad dolor commodo non occaecat fugiat eu. Incididunt eu ullamco labore Lorem enim non aliqua. Id et ipsum labore commodo pariatur proident excepteur et.",
                    "Qui qui ad dolor commodo non occaecat fugiat eu. Incididunt eu ullamco labore Lorem enim non aliqua. Id et ipsum labore commodo pariatur proident excepteur et."
                ],
            },
            {
                align: 'right',
                title: "Find right videos and talents with advance filters",
                image: {dark: FILTERS_DARK, default: FILTERS},
                texts: [
                    "Qui qui ad dolor commodo non occaecat fugiat eu. Incididunt eu ullamco labore Lorem enim non aliqua. Id et ipsum labore commodo pariatur proident excepteur et.",
                    "Qui qui ad dolor commodo non occaecat fugiat eu. Incididunt eu ullamco labore Lorem enim non aliqua. Id et ipsum labore commodo pariatur proident excepteur et."
                ],
            },
            {
                title: "Watchlist to track players and team performances",
                image: {dark: WATCHLIST_DARK, default: WATCHLIST},
                texts: [
                    "Qui qui ad dolor commodo non occaecat fugiat eu. Incididunt eu ullamco labore Lorem enim non aliqua. Id et ipsum labore commodo pariatur proident excepteur et.",
                    "Qui qui ad dolor commodo non occaecat fugiat eu. Incididunt eu ullamco labore Lorem enim non aliqua. Id et ipsum labore commodo pariatur proident excepteur et."
                ],
            },
            {
                align: 'right',
                title: "Discuss ideas and solution with other professionals",
                image: {dark: METRICS_DARK, default: METRICS},
                texts: [
                    "Qui qui ad dolor commodo non occaecat fugiat eu. Incididunt eu ullamco labore Lorem enim non aliqua. Id et ipsum labore commodo pariatur proident excepteur et.",
                    "Qui qui ad dolor commodo non occaecat fugiat eu. Incididunt eu ullamco labore Lorem enim non aliqua. Id et ipsum labore commodo pariatur proident excepteur et."
                ],
            },
            {
                title: "Compare player performances and metrics",
                image: {dark: MESSAGE_DARK, default: MESSAGE},
                texts: [
                    "Qui qui ad dolor commodo non occaecat fugiat eu. Incididunt eu ullamco labore Lorem enim non aliqua. Id et ipsum labore commodo pariatur proident excepteur et.",
                    "Qui qui ad dolor commodo non occaecat fugiat eu. Incididunt eu ullamco labore Lorem enim non aliqua. Id et ipsum labore commodo pariatur proident excepteur et."
                ],
            },
            {
                align: 'right',
                title: "Detailed player evaluations with ease",
                image: {dark: EVALUATION_DARK, default: EVALUATION},
                texts: [
                    "Qui qui ad dolor commodo non occaecat fugiat eu. Incididunt eu ullamco labore Lorem enim non aliqua. Id et ipsum labore commodo pariatur proident excepteur et.",
                    "Qui qui ad dolor commodo non occaecat fugiat eu. Incididunt eu ullamco labore Lorem enim non aliqua. Id et ipsum labore commodo pariatur proident excepteur et."
                ],
            },
        ],
        testimonials: [
            {
                image: require('../../../../assets/img/demo/testimonial-avatar.png'),
                title: 'Jack Smith',
                subtitle: 'Scout | Chelsea',
                text: 'Qui qui ad dolor commodo non occaecat fugiat eu. Incididunt eu ullamco labore Lorem enim non aliqua. Id et ipsum labore commodo pariatur proident excepteur et.'
            },
            {
                image: require('../../../../assets/img/demo/testimonial-avatar.png'),
                title: 'Jhon Smith',
                subtitle: 'Scout | Chelsea',
                text: 'Qui qui ad dolor commodo non occaecat fugiat eu. Incididunt eu ullamco labore Lorem enim non aliqua. Id et ipsum labore commodo pariatur proident excepteur et qui ad dolor commodo non occaecat fugiat eu. Incididunt eu ullamco labore Lorem enim non aliqua. qui ad dolor commodo non occaecat fugiat eu. Incididunt eu ullamco labore Lorem enim non aliqua.'
            },
            {
                image: require('../../../../assets/img/demo/testimonial-avatar.png'),
                title: 'Mark Smith',
                subtitle: 'Scout | Chelsea',
                text: 'Qui qui ad dolor commodo non occaecat fugiat eu. Incididunt eu ullamco labore Lorem enim non aliqua. Id et ipsum labore commodo pariatur proident excepteur et.'
            },
            {
                image: require('../../../../assets/img/demo/testimonial-avatar.png'),
                title: 'Will Smith',
                subtitle: 'Scout | Chelsea',
                text: 'Qui qui ad dolor commodo non occaecat fugiat eu. Incididunt eu ullamco labore Lorem enim non aliqua. Id et ipsum labore commodo pariatur proident excepteur et.'
            },
        ],
    }
}

export default Landing